export default "__VITE_ASSET__b0767712__"